import { useSelector } from 'react-redux'
import { getFeatureFlag } from 'ggx-service/feature-flag/selectors'
import { MultipleTunnelSelection } from './multiple-tunnel-selection.component'
import { MultipleTunnelModal } from './multiple-tunnel-modal.component.js'
import { TunnelServiceItems } from './tunnel-service-items.component'

export default {
  useEnableSmartTunnelSuggestion() {
    return useSelector(state =>
      getFeatureFlag({
        state,
        featureFlag: 'enable_smart_tunnel_suggestion',
      })
    )
  },
  MultipleTunnelSelection,
  MultipleTunnelModal,
  TunnelServiceItems,
}
